import * as React from "react";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { Spin } from "Components/General/Spin";
import { ColumnProps } from "antd/lib/table";
import { FolderRelationsSymlinkInfoActions } from "./FolderRelationsSymlinkInfoActions";
import { documentsTableStore } from "../../Stores/DocumentsTableStore";
import { Table } from "Components/General/Table";

interface FolderRelationsProps {
  folderId: number;
}

export const FolderRelations = observer(({ folderId }: FolderRelationsProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  React.useEffect(() => {
    (async () => {
      documentsTableStore.getFolderRelations(folderId);
    })();
  }, []);

  const symLinkColumns: ColumnProps<API_FolderRelationsSymlinkInfo>[] = [
    {
      dataIndex: "targetProjectName",
      title: t("Destination project"),
      width: 200,
    },
    {
      dataIndex: "targetPath",
      title: t("Destination directory"),
      width: 500,
    },
    {
      dataIndex: "name",
      title: t("Name"),
      width: 200,
    },
    {
      dataIndex: "id",
      title: t("Actions"),
      width: 80,
      align: "center",
      render: (val: number, record: API_FolderRelationsSymlinkInfo) => (
        <FolderRelationsSymlinkInfoActions data={record} />
      ),
    },
  ];

  const { symlinkInfo } = documentsTableStore.folderRelations;

  return (
    <Spin spinning={!symlinkInfo}>
      <div>
        {symlinkInfo ? (
          <>
            <h3>{t("Is link to")}:</h3>
            <Table
              name="folderRelations"
              pagination={false}
              dataSource={symlinkInfo}
              columns={symLinkColumns}
              rowKey={(_record, index) => `${index}`}
              className="mb-md"
            />
          </>
        ) : null}
      </div>
    </Spin>
  );
});
